"use strict";

import axios from 'axios';

let token = window.gCsrfToken || null;
if ( token !== null && token.content )
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
///axios.defaults.headers.common['Authorization'] = 'Bearer mxM5aW15HQ49pGwlUSz4NwnXg50ij62mqfmkugwtrokTPxGBEJK6DnOhD7Jd';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.baseURL = window.location.origin + '/api/v1';
axios.interceptors.response.use((response) => {
    return response;
}, err => {
    if(axios.isCancel(err))
        return Promise.reject(err);
    const error = err.response;
    if (!!error && error.status === 401) {
        console.log('Unauthorized');
        window.location = window.location.origin + '/accounts';
        return Promise.reject(error);
    }
    return Promise.reject(error);
});
export default axios;
